<div class="filter-wrapper" *transloco="let t">
  @if (titleLabel) {
    <p class="text">{{ t(descriptionKey) }}</p>
  }

  <form [formGroup]="searchForm" class="filter-form">
    @if (filterFields?.standard) {
      <div class="standard-filter">
        @for (filterField of filterFields.standard; track filterField.name) {
          <!-- Input Field -->
          @if (!isFilterFieldDropdown(filterField)) {
            <xt-ui-kit-input-field
              [formControlName]="filterField.name"
              [svgIcon]="filterField.svgIcon"
              [dataCy]="'privacyCockpit.filterForm.name'"
              [width]="getInputWidth(filterField)"
              [placeholder]="
                t(filterField.placeholder) + (filterField.required ? '*' : '')
              "
            />
          }
          <!-- Dropdown Field -->
          @else {
            @if (filterField.entries$ | async; as entries) {
              <xt-portal-dropdown
                ngDefaultControl
                [isDisabled]="entries.length === 1"
                [formControlName]="filterField.name"
                [dataCy]="'privacyCockpit.filterField.name'"
                [entries]="entries"
                [hidden]="shouldHideDropdown(filterField, entries)"
                [label]="
                  t(filterField.label) + (filterField.required ? '*' : '')
                "
                [preselectFirst]="getPreselectFirst(filterField)"
                [dropdownValue]="getDropdownValueForField(filterField.name)"
                (selectedElement)="onSelectDropdown($event, filterField.name)"
              />
            }
          }
        }
      </div>
    }
    @if (filterFields?.advanced) {
      <div class="expanded-filter-wrapper accordion-wrapper standard">
        <mat-accordion [hideToggle]="false">
          <mat-expansion-panel [hideToggle]="false" class="mat-elevation-z">
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <span>
                  {{ 'app.privacyCockpit.advancedSearch' | transloco }}
                </span>
                <hr class="horizontal-line" />
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="expanded-filter">
              @for (
                filterField of filterFields.advanced;
                track filterField.name
              ) {
                <!-- Input Field -->
                @if (!isFilterFieldDropdown(filterField)) {
                  <xt-ui-kit-input-field
                    [formControlName]="filterField.name"
                    [placeholder]="t(filterField.placeholder || '')"
                    [svgIcon]="filterField.svgIcon"
                    [dataCy]="'privacyCockpit.filterField.advanced.name'"
                    [width]="getInputWidth(filterField)"
                  />
                }
                <!-- Dropdown Field -->
                @else {
                  @if (filterField.entries$ | async; as entries) {
                    <xt-portal-dropdown
                      ngDefaultControl
                      [hidden]="!entries.length"
                      [isDisabled]="entries.length === 1"
                      [formControlName]="filterField.name"
                      [label]="t(filterField.label)"
                      [entries]="entries"
                      [dropdownValue]="dropdownValue"
                      [dataCy]="'privacyCockpit.filterField.advanced.dropdown.name'"
                      [preselectFirst]="getPreselectFirst(filterField)"
                      (selectedElement)="
                        onSelectDropdown($event, filterField.name)
                      "
                    />
                  }
                }
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    }

    <div class="search-filter-wrapper">
      <xt-portal-button
        class="filter-button blue-link"
        icon="close"
        color="none"
        width="small"
        [text]="t('app.filterbar.resetFilter')"
        [xTentionDummyCypress]="'search.reset-filter'"
        (clickEvent)="resetFilter()"
      />
      <xt-portal-button
        [text]="t('app.labels.search')"
        [disabled]="!isSearchEnabled"
        color="primary"
        (clickEvent)="search()"
        [xTentionDummyCypress]="'privacyCockpit.filterForm.search'"
      />
    </div>
  </form>
</div>
